import type { FC } from "react";

import type { CheckoutOrderSummarySocialMedia } from "@jti/commerce";
import { useCheckoutConfiguration } from "@jti/commerce/providers";

import { SocialIcon } from "./SocialIcon";

import styles from "./SocialMedia.module.scss";

export const SocialMedia: FC = () => {
  const { orderSummaryConfig } = useCheckoutConfiguration();
  const { socialMedia, displaySocialMedia, socialMediaTitle } = orderSummaryConfig;

  if (!displaySocialMedia || !socialMedia) return null;
  if (socialMedia?.length === 0) return null;

  return (
    <div className={styles.container} data-testid="socialMedia">
      <h5 className={styles.title}>{socialMediaTitle}</h5>
      <div className={styles.linksContainer}>
        {socialMedia.map((link: CheckoutOrderSummarySocialMedia) => (
          <SocialIcon link={link} key={link.uri} />
        ))}
      </div>
    </div>
  );
};
